import type { ClassValue } from 'clsx'
import { clsx } from 'clsx'
import { extendTailwindMerge } from 'tailwind-merge'

const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      // Register @theme font sizes so they don't conflict with text-* colors in twMerge.
      'font-size': [
        {
          text: [
            'heading-h1',
            'heading-h2',
            'heading-h3',
            'heading-h4',
            'heading-h5',
            'heading-h6',
            'body-lg',
            'body-base',
            'body-sm',
            'body-xs',
            'label-lg',
            'label-base',
            'label-sm',
            'label-xs',
            'eyebrow',
            'code-base',
            'code-sm',
          ],
        },
      ],
    },
  },
})

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
